import ComponentRenderer from '@components/cms-components/component-renderer';
import PageIndexList from '@components/page-index/page-index-list.view';
import TextBlock from '@components/text-block';
import type { ReactElement } from 'react';
import React from 'react';
import type { PageIndex, PageIndexLayout } from 'types/components/page-index';
import type { DataProps } from 'types/props/data-props';
import { validateString } from 'utils/validate-string';

import styles from './page-index.module.scss';

const textBlockClass = validateString(styles.textBlockClass);

function PageIndexComponent({
  context,
  eyebrow,
  heading,
  subHeading,
  description,
  indexEntries,
  layout = 'cards',
}: Readonly<DataProps<PageIndex>>): ReactElement {
  const mapLayoutToList = (listLayout: PageIndexLayout): ReactElement => {
    switch (listLayout) {
      case 'cards':
      default: {
        return <PageIndexList pageIndexEntries={indexEntries} />;
      }
    }
  };

  return (
    <div>
      <div className={textBlockClass}>
        <TextBlock
          description={
            <ComponentRenderer context={context}>
              {description}
            </ComponentRenderer>
          }
          eyebrow={eyebrow}
          heading={heading}
          size="small"
          subHeading={subHeading}
        />
      </div>

      {mapLayoutToList(layout)}
    </div>
  );
}

export default PageIndexComponent;
